import React from 'react';
import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

// Offsets account for fixed chrome: SiteNav (~64px top) and Player (~80px bottom).
const POSITIONS = {
  TL: { top: 'clamp(80px, 8vw, 104px)',    left: 'clamp(24px, 3vw, 48px)', textAlign: 'left',  alignItems: 'flex-start' },
  TR: { top: 'clamp(80px, 8vw, 104px)',    right:'clamp(24px, 3vw, 48px)', textAlign: 'right', alignItems: 'flex-end'   },
  BL: { bottom:'clamp(100px, 9vw, 124px)', left: 'clamp(24px, 3vw, 48px)', textAlign: 'left',  alignItems: 'flex-start' },
  BR: { bottom:'clamp(100px, 9vw, 124px)', right:'clamp(24px, 3vw, 48px)', textAlign: 'right', alignItems: 'flex-end'   },
};

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0 } },
};

const line = {
  hidden:  { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: EASE } },
};

export default function MetaCorner({ position, lines = [], children, animate, hideOnMobile = false }) {
  const pos = POSITIONS[position] || POSITIONS.TL;

  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate={animate ? 'visible' : 'hidden'}
      style={{
        position: 'absolute',
        ...pos,
        display: 'flex',
        flexDirection: 'column',
        gap: '0.6em',
        zIndex: 12,
        pointerEvents: 'none',
      }}
      className={hideOnMobile ? 'meta-hide-mobile' : undefined}
    >
      {lines.map((text, i) => (
        <motion.span
          key={i}
          variants={line}
          style={{
            fontFamily: 'var(--mono)',
            fontSize: 'clamp(9px, 0.7vw, 11px)',
            letterSpacing: '0.28em',
            textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.4)',
            whiteSpace: 'nowrap',
          }}
        >
          {text}
        </motion.span>
      ))}
      {children && (
        <motion.div variants={line} style={{ pointerEvents: 'auto' }}>
          {children}
        </motion.div>
      )}
    </motion.div>
  );
}
